/* eslint-disable react/prop-types */
import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import {
  Table, Select, notification,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import TenantActions from '@Actions/tenantActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import BusyIntegrationActions from '../../../../../../../actions/integrations/busyIntegrationAction';
import BusyTabLoading from '../../BusyTabLoading';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const BusyMapUOM = ({
  user, getTenants, getTenantsLoading, tenants, connectToBusyLocationLoading,
  setStep, getBusyConnectionsLoading,
  connectToBusyLocation, integrationBusyId, busyConnection, stepNumber,
}) => {
  const [selectedBusyConnection, setSelectedBusyConnection] = useState('');
  const [uomMapping, setUomMapping] = useState('');

  useEffect(() => {
    setSelectedBusyConnection(busyConnection);
    const _uomMapping = (busyConnection?.uom_mapping || [])?.map((tenant) => ({
      key: uuidv4(),
      busy_uom: tenant?.busy_uom,
      procuzy_uom: tenant?.procuzy_uom,
    }));
    setUomMapping(_uomMapping);
  }, [busyConnection]);

  useEffect(() => {
    getTenants(1, '', true, user?.tenant_info?.org_id);
  }, []);

  const updateTableValue = (key, value, label) => {
    const data = uomMapping?.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setUomMapping(data);
  };

  const handleSubmit = () => {
    if (uomMapping?.length > 0) {
      const payload = {
        integration_busy_id: selectedBusyConnection.integration_busy_id,
        uom_mapping: uomMapping.filter((obj) => obj.busy_uom !== undefined && obj.busy_uom !== null),
      };

      connectToBusyLocation(payload, () => {
        setStep(Number(stepNumber) + 1);
      });
    } else {
      notification.error({
        message: 'Please select at least one UOM',
        placement: 'top',
        duration: 4,
      });
    }
  };

  if (getBusyConnectionsLoading || !selectedBusyConnection) return <BusyTabLoading />;

  const columns = [
    {
      title: 'Procuzy UOM',
      width: '160px',
      render: (record) => (
        <div>
          {record?.procuzy_uom}
        </div>
      ),
    },
    {
      title: 'Busy UOM',
      render: (record) => (
        <div>
          <PRZSelect
            value={record.busy_uom}
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.key, value, 'busy_uom');
            }}
            placeholder="Select a UOM"
            allowClear
            disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
          >
            {selectedBusyConnection?.units
              ?.map((item) => (
                <Option key={item.name} value={item.name}>
                  {item?.name}
                </Option>
              ))}
          </PRZSelect>
        </div>
      ),
    },
  ];

  return (
    <div className="busy__uom-wrapper">
      <div className="ant-row">
        <div className="ant-col-md-12">
          <Table
            columns={columns}
            loading={getTenantsLoading || connectToBusyLocationLoading || getBusyConnectionsLoading}
            dataSource={uomMapping}
            size="small"
            pagination={false}
            scroll={{ y: 400 }}
            bordered
          />
        </div>
      </div>
      <div className="ant-row" style={{ display: 'flex', marginTop: '20px' }}>
        <H3Button
          text="Back"
          buttonType={defaultButtonTypes.BLUE_BORDERED}
          onClick={() => setStep(Number(stepNumber) - 1)}
          customClass="busy__action-button"
          disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
        />
                &nbsp;&nbsp;
                &nbsp;&nbsp;
        <div>
          <H3Button
            text="Save and Continue"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => handleSubmit()}
            customClass="busy__location-submit"
            isLoading={connectToBusyLocationLoading || getBusyConnectionsLoading}
            disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, BusyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  connectToBusyLocationLoading: BusyIntegrationReducers.connectToBusyLocationLoading,
  getBusyConnectionsLoading: BusyIntegrationReducers.getBusyConnectionsLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  busyConnections: BusyIntegrationReducers.busyConnections,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getBusyConnections: (orgId, callback) => dispatch(BusyIntegrationActions.getBusyConnections(orgId, callback)),
  connectToBusyLocation: (payload, callback) => dispatch(BusyIntegrationActions.connectToBusyLocation(payload, callback)),
});

BusyMapUOM.propTypes = {
  user: PropTypes.any,
  getTenants: PropTypes.func,
  getBusyConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  tenants: PropTypes.any,
  connectToBusyLocationLoading: PropTypes.bool,
  setStep: PropTypes.func,
  getBusyConnections: PropTypes.func,
  connectToBusyLocation: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusyMapUOM));
